// // // // src/pages/DermatologyScreen.tsx
// // // import React, { useState } from "react";
// // // import { useParams, useNavigate } from "react-router-dom";
// // // import "../css/DermatologyScreen.css";
// // // import DermSummaryTab from "../components/dermatology/DermSummaryTab";
// // // import DermImageViewerTab from "../components/dermatology/DermImageViewerTab";
// // // import DermReportTab from "../components/dermatology/DermReportTab";
// // // import { useAuth } from "../context/AuthContext";

// // // type ActiveTab = "summary" | "imageViewer" | "report";

// // // type SubTab = "derma" | "ad";

// // // // Define the shape of the recommendations state
// // // export interface ReportRecommendations {
// // //   none: boolean;
// // //   followAdvice: boolean;
// // //   consultDerm: boolean;
// // // }

// // // const DermatologyScreen: React.FC = () => {
// // //   const { emrNumber } = useParams<{ emrNumber: string }>();
// // //   const { doctor } = useAuth();
// // //   const emrId = emrNumber ?? "";

// // //   const patientAge = 4; // already visible in UI
// // //   const doctorName = doctor ? `Dr. ${doctor.name}` : "";
// // //   const userId = doctor?.id || doctor?.userId || "";

// // //   const navigate = useNavigate();
// // //   const [activeTab, setActiveTab] = useState<ActiveTab>("summary");

// // //   const [activeSubTab, setActiveSubTab] = useState<SubTab>("derma");

// // //   // --- State for the shared Report Writing section ---
// // //   const [telePrognosis, setTelePrognosis] = useState("");
// // //   const [medicalAdvice, setMedicalAdvice] = useState("");
// // //   const [recommendations, setRecommendations] = useState<ReportRecommendations>(
// // //     {
// // //       none: false,
// // //       followAdvice: false,
// // //       consultDerm: false,
// // //     },
// // //   );

// // //   // Create a props object to pass down to children
// // //   const reportProps = {
// // //     emrId,
// // //     patientAge,
// // //     doctorName,
// // //     userId,
// // //     telePrognosis,
// // //     setTelePrognosis,
// // //     medicalAdvice,
// // //     setMedicalAdvice,
// // //     recommendations,
// // //     setRecommendations,
// // //   };

// // //   return (
// // //   <div className="derm-screen">
// // //     <div className="screen-header-row">
// // //       <button
// // //         onClick={() => navigate("/queue/dermatology")}
// // //         className="back-button"
// // //       >
// // //         &larr; Back to Patient List
// // //       </button>

// // //       <div className="patient-info">
// // //         <span>
// // //           <strong>EMR Number:</strong> {emrId}
// // //         </span>
// // //         <span>
// // //           <strong>Age:</strong> {patientAge} years
// // //         </span>
// // //       </div>
// // //     </div>

// // //     {/* MAIN LAYOUT */}
// // //     <div className="derm-main-layout">

// // //       {/* LEFT SIDEBAR */}
// // //       <div className="derm-sidebar">
// // //         <button
// // //           className={`derm-tab ${activeTab === "summary" ? "active" : ""}`}
// // //           onClick={() => setActiveTab("summary")}
// // //         >
// // //           Summary
// // //         </button>

// // //         <button
// // //           className={`derm-tab ${activeTab === "imageViewer" ? "active" : ""}`}
// // //           onClick={() => setActiveTab("imageViewer")}
// // //         >
// // //           Images
// // //         </button>

// // //         <button
// // //           className={`derm-tab ${activeTab === "report" ? "active" : ""}`}
// // //           onClick={() => setActiveTab("report")}
// // //         >
// // //           Report
// // //         </button>
// // //       </div>

// // //       {/* RIGHT CONTENT */}
// // //       <div className="derm-right-content">

// // //         {/* ✅ SUB TABS ONLY FOR SUMMARY */}
// // //         {activeTab === "summary" && (
// // //           <div className="derm-sub-tabs-container">
// // //             <button
// // //               className={`derm-sub-tab ${
// // //                 activeSubTab === "derma" ? "active" : ""
// // //               }`}
// // //               onClick={() => setActiveSubTab("derma")}
// // //             >
// // //               Derma Symptoms
// // //             </button>

// // //             <button
// // //               className={`derm-sub-tab ${
// // //                 activeSubTab === "ad" ? "active" : ""
// // //               }`}
// // //               onClick={() => setActiveSubTab("ad")}
// // //             >
// // //               AD Symptoms
// // //             </button>
// // //           </div>
// // //         )}

// // //         {/* CONTENT */}
// // //         {activeTab === "summary" && (
// // //           <DermSummaryTab
// // //             {...reportProps}
// // //             activeSubTab={activeSubTab}
// // //             onSubmitSuccess={() => setActiveTab("imageViewer")}
// // //           />
// // //         )}

// // //         {activeTab === "imageViewer" && (
// // //           <DermImageViewerTab
// // //             emrId={emrId!}
// // //             patientAge={patientAge}
// // //             doctorName={doctorName}
// // //             userId={userId}
// // //           />
// // //         )}

// // //         {activeTab === "report" && (
// // //           <DermReportTab
// // //             emrId={emrId}
// // //             patientAge={patientAge}
// // //             doctorName={doctorName}
// // //             userId={userId}
// // //           />
// // //         )}
// // //       </div>
// // //     </div>
// // //   </div>
// // //   );
// // // };

// // // export default DermatologyScreen;



// // // //   return (
// // // //     <div className="derm-screen">
// // // //       <div className="screen-header-row">
// // // //         {/* This back button was commented out in your provided file, assuming it's needed */}
// // // //         <button
// // // //           onClick={() => navigate("/queue/dermatology")}
// // // //           className="back-button"
// // // //         >
// // // //           &larr; Back to Patient List
// // // //         </button>
// // // //         <div className="patient-info">
// // // //           <span>
// // // //             <strong>EMR Number:</strong> {emrId}
// // // //           </span>
// // // //           <span>
// // // //             <strong>Age:</strong> {patientAge} years
// // // //           </span>
// // // //         </div>
// // // //       </div>

// // // //       {/* <div className="derm-tabs-container">
// // // //         <button
// // // //           className={`derm-tab ${activeTab === "summary" ? "active" : ""}`}
// // // //           onClick={() => setActiveTab("summary")}
// // // //         >
// // // //           Summary
// // // //         </button>
// // // //         <button
// // // //           className={`derm-tab ${activeTab === "imageViewer" ? "active" : ""}`}
// // // //           onClick={() => setActiveTab("imageViewer")}
// // // //         >
// // // //           Image viewer
// // // //         </button>
// // // //         <button
// // // //           className={`derm-tab ${activeTab === "report" ? "active" : ""}`}
// // // //           onClick={() => setActiveTab("report")}
// // // //         >
// // // //           Report Writing
// // // //         </button>
// // // //       </div> */}

// // // //       <div className="derm-sub-tabs-container">
// // // //         <button
// // // //           className={`derm-sub-tab ${activeSubTab === "derma" ? "active" : ""}`}
// // // //           onClick={() => setActiveSubTab("derma")}
// // // //         >
// // // //           Derma Symptoms
// // // //         </button>

// // // //         <button
// // // //           className={`derm-sub-tab ${activeSubTab === "ad" ? "active" : ""}`}
// // // //           onClick={() => setActiveSubTab("ad")}
// // // //         >
// // // //           AD Symptoms
// // // //         </button>
// // // //       </div>

// // // //       {/* <div className="derm-content"> */}
// // // //       <div className="derm-main-layout">
// // // //         {/* {activeTab === "summary" && (
          
// // // //           <DermSummaryTab
// // // //             {...reportProps}
// // // //             activeSubTab={activeSubTab}
// // // //             onSubmitSuccess={() => setActiveTab("imageViewer")}
// // // //           />
// // // //         )}
// // // //         {activeTab === "imageViewer" && (
// // // //           <DermImageViewerTab
// // // //             emrId={emrId!}
// // // //             patientAge={patientAge}
// // // //             doctorName={doctorName}
// // // //             userId={userId}
// // // //             // activeSubTab={activeSubTab}
// // // //           />
// // // //         )}
// // // //         {activeTab === "report" && (
// // // //           <DermReportTab
// // // //             emrId={emrId}
// // // //             patientAge={patientAge}
// // // //             doctorName={doctorName}
// // // //             userId={userId}
// // // //             // activeSubTab={activeSubTab}
// // // //           />
// // // //         )} */}

// // // //         <div className="derm-sidebar">
// // // //           <button
// // // //             className={`derm-tab ${activeTab === "summary" ? "active" : ""}`}
// // // //             onClick={() => setActiveTab("summary")}
// // // //           >
// // // //             Summary
// // // //           </button>

// // // //           <button
// // // //             className={`derm-tab ${activeTab === "imageViewer" ? "active" : ""}`}
// // // //             onClick={() => setActiveTab("imageViewer")}
// // // //           >
// // // //             Images
// // // //           </button>

// // // //           <button
// // // //             className={`derm-tab ${activeTab === "report" ? "active" : ""}`}
// // // //             onClick={() => setActiveTab("report")}
// // // //           >
// // // //             Report
// // // //           </button>
// // // //         </div>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default DermatologyScreen;









// // // src/pages/DermatologyScreen.tsx

// // import React, { useEffect, useState } from "react";
// // import { useParams, useNavigate } from "react-router-dom";
// // import "../css/DermatologyScreen.css";

// // import DermSummaryTab from "../components/dermatology/DermSummaryTab";
// // import DermImageViewerTab from "../components/dermatology/DermImageViewerTab";
// // import DermReportTab from "../components/dermatology/DermReportTab";

// // import { useAuth } from "../context/AuthContext";
// // import api from "../api/axiosConfig";

// // type ActiveTab = "summary" | "imageViewer" | "report";
// // type SubTab = "derma" | "ad";

// // export interface ReportRecommendations {
// //   none: boolean;
// //   followAdvice: boolean;
// //   consultDerm: boolean;
// // }

// // const DermatologyScreen: React.FC = () => {
// //   const { emrNumber } = useParams<{ emrNumber: string }>();
// //   const navigate = useNavigate();
// //   const { doctor } = useAuth();

// //   const emrId = emrNumber ?? "";

// //   const patientAge = 4;
// //   const doctorName = doctor ? `Dr. ${doctor.name}` : "";
// //   const userId = doctor?.id || doctor?.userId || "";

// //   const [activeTab, setActiveTab] = useState<ActiveTab>("summary");
// //   const [activeSubTab, setActiveSubTab] = useState<SubTab>("derma");

// //   // NEW
// //   const [showADTab, setShowADTab] = useState(false);
// //   const [loadingScore, setLoadingScore] = useState(true);

// //   // Shared Report State
// //   const [telePrognosis, setTelePrognosis] = useState("");
// //   const [medicalAdvice, setMedicalAdvice] = useState("");

// //   const [recommendations, setRecommendations] =
// //     useState<ReportRecommendations>({
// //       none: false,
// //       followAdvice: false,
// //       consultDerm: false,
// //     });

// //   // =====================================================
// //   // FETCH QUESTION 1220
// //   // =====================================================
// //   // useEffect(() => {
// //   //   const loadScoring = async () => {
// //   //     try {
// //   //       const res = await api.dataCollectionApi.get(
// //   //         `/questionnair/api/scoring/scoresId/${emrId}/health`
// //   //       );

// //   //       const answer =
// //   //         res?.data?.scores?.resultsById?.["1220"] || "";

// //   //       const normalized = String(answer).toLowerCase();

// //   //       if (
// //   //         normalized === "yes" ||
// //   //         normalized === "maybe"
// //   //       ) {
// //   //         setShowADTab(true);
// //   //       } else {
// //   //         setShowADTab(false);
// //   //         setActiveSubTab("derma");
// //   //       }
// //   //     } catch (error) {
// //   //       console.error("Failed to load scoring", error);

// //   //       // safe fallback
// //   //       setShowADTab(false);
// //   //       setActiveSubTab("derma");
// //   //     } finally {
// //   //       setLoadingScore(false);
// //   //     }
// //   //   };

// //   //   if (emrId) {
// //   //     loadScoring();
// //   //   }
// //   // }, [emrId]);



// // //   useEffect(() => {
// // //   const loadScoring = async () => {
// // //     try {
// // //       // TEMP STATIC TEST EMR
// // //       const testEmr = "P-2026-000049-9";

// // //       const res = await api.dataCollectionApi.get(
// // //         `/questionnair/api/scoring/scoresId/${testEmr}/health`
// // //       );

// // //       const answer =
// // //         res?.data?.scores?.resultsById?.["1220"] || "";

// // //       const normalized = String(answer).toLowerCase();

// // //       if (
// // //         normalized === "yes" ||
// // //         normalized === "maybe"
// // //       ) {
// // //         setShowADTab(true);
// // //       } else {
// // //         setShowADTab(false);
// // //         setActiveSubTab("derma");
// // //       }
// // //     } catch (error) {
// // //       console.error(error);
// // //       setShowADTab(false);
// // //     } finally {
// // //       setLoadingScore(false);
// // //     }
// // //   };

// // //   loadScoring();
// // // }, []);




// // // useEffect(() => {
// // //   const loadScoring = async () => {
// // //     try {
// // //       const testEmr = "P-2026-000049-9";

// // //       const res = await api.dataCollectionApi.get(
// // //         `/questionnair/api/scoring/scoresId/${testEmr}/health weather`
// // //       );

// // //       const answer = res?.data?.scores?.resultsById?.["1220"];

// // //       console.log("1220 Answer =", answer);

// // //       const normalized = String(answer || "")
// // //         .trim()
// // //         .toLowerCase();

// // //       const shouldShow =
// // //         normalized === "yes" ||
// // //         normalized === "maybe";

// // //       setShowADTab(shouldShow);

// // //       if (!shouldShow) {
// // //         setActiveSubTab("derma");
// // //       }

// // //       console.log("showADTab =", shouldShow);

// // //     } catch (error) {
// // //       console.error("Scoring API failed", error);
// // //       setShowADTab(false);
// // //       setActiveSubTab("derma");
// // //     } finally {
// // //       setLoadingScore(false);
// // //     }
// // //   };

// // //   loadScoring();
// // // }, []);

// // // useEffect(() => {
// // //   const loadScoring = async () => {
// // //     try {
// // //       // TEMP STATIC EMR FOR TESTING
// // //       const testEmr = "P-2026-000049-9";

// // //       const res = await api.dataCollectionApi.get(
// // //         `/questionnair/api/scoring/scoresId/${testEmr}/health weather`
// // //       );

// // //       const answer =
// // //         res?.data?.scores?.resultsById?.["1220"];

// // //       console.log("1220 =", answer);

// // //       const normalized = String(answer || "")
// // //         .trim()
// // //         .toLowerCase();

// // //       const shouldShow =
// // //         normalized === "yes" ||
// // //         normalized === "maybe";

// // //       setShowADTab(shouldShow);

// // //       if (shouldShow) {
// // //         setActiveSubTab("ad");
// // //       } else {
// // //         setActiveSubTab("derma");
// // //       }

// // //     } catch (error) {
// // //       console.error("Scoring API failed", error);

// // //       setShowADTab(false);
// // //       setActiveSubTab("derma");
// // //     } finally {
// // //       setLoadingScore(false);
// // //     }
// // //   };

// // //   loadScoring();
// // // }, []);

// // useEffect(() => {
// //   const loadScoring = async () => {
// //     try {
// //       if (!emrId) return;

// //       const res = await api.dataCollectionApi.get(
// //         `/questionnair/api/scoring/scoresId/${emrId}/health`
// //       );

// //       const answer =
// //         res?.data?.scores?.resultsById?.["1220"];

// //       const normalized = String(answer || "")
// //         .trim()
// //         .toLowerCase();

// //       const shouldShow =
// //         normalized === "yes" ||
// //         normalized === "maybe";

// //       setShowADTab(shouldShow);

// //       setActiveSubTab(
// //         shouldShow ? "ad" : "derma"
// //       );

// //     } catch (error) {
// //       console.error(
// //         "Failed to load scoring",
// //         error
// //       );

// //       setShowADTab(false);
// //       setActiveSubTab("derma");
// //     } finally {
// //       setLoadingScore(false);
// //     }
// //   };

// //   loadScoring();
// // }, [emrId]);

// //   const reportProps = {
// //     emrId,
// //     patientAge,
// //     doctorName,
// //     userId,
// //     telePrognosis,
// //     setTelePrognosis,
// //     medicalAdvice,
// //     setMedicalAdvice,
// //     recommendations,
// //     setRecommendations,
// //     showADTab, // send to child
// //   };

// //   if (loadingScore) {
// //     return <div className="loading-state">Loading...</div>;
// //   }

// //   return (
// //     <div className="derm-screen">
// //       {/* HEADER */}
// //       <div className="screen-header-row">
// //         <button
// //           onClick={() => navigate("/queue/dermatology")}
// //           className="back-button"
// //         >
// //           &larr; Back to Patient List
// //         </button>

// //         <div className="patient-info">
// //           <span>
// //             <strong>EMR Number:</strong> {emrId}
// //           </span>

// //           <span>
// //             <strong>Age:</strong> {patientAge} years
// //           </span>
// //         </div>
// //       </div>

// //       {/* MAIN */}
// //       <div className="derm-main-layout">

// //         {/* SIDEBAR */}
// //         <div className="derm-sidebar">
// //           <button
// //             className={`derm-tab ${
// //               activeTab === "summary" ? "active" : ""
// //             }`}
// //             onClick={() => setActiveTab("summary")}
// //           >
// //             Summary
// //           </button>

// //           <button
// //             className={`derm-tab ${
// //               activeTab === "imageViewer" ? "active" : ""
// //             }`}
// //             onClick={() => setActiveTab("imageViewer")}
// //           >
// //             Images
// //           </button>

// //           <button
// //             className={`derm-tab ${
// //               activeTab === "report" ? "active" : ""
// //             }`}
// //             onClick={() => setActiveTab("report")}
// //           >
// //             Report
// //           </button>
// //         </div>

// //         {/* RIGHT */}
// //         <div className="derm-right-content">

// //           {/* SUB TABS */}
// //          {(activeTab === "summary" ||
// //   activeTab === "imageViewer" ||
// //   activeTab === "report") && (
// //   <div className="derm-sub-tabs-container">

// //               <button
// //                 className={`derm-sub-tab ${
// //                   activeSubTab === "derma" ? "active" : ""
// //                 }`}
// //                 onClick={() => setActiveSubTab("derma")}
// //               >
// //                 Derma Symptoms
// //               </button>

// //               {/* ONLY IF YES / MAYBE */}
// //               {showADTab && (
// //                 <button
// //                   className={`derm-sub-tab ${
// //                     activeSubTab === "ad" ? "active" : ""
// //                   }`}
// //                   onClick={() => setActiveSubTab("ad")}
// //                 >
// //                   AD Symptoms
// //                 </button>
// //               )}
// //             </div>
// //           )}

// //           {/* CONTENT */}
// //           {/* {activeTab === "summary" && (
// //             <DermSummaryTab
// //               {...reportProps}
// //               activeSubTab={activeSubTab}
// //               onSubmitSuccess={() =>
// //                 setActiveTab("imageViewer")
// //               }
// //             />
// //           )}

// //           {activeTab === "imageViewer" && (
// //  <DermReportTab
// //   emrId={emrId}
// //   patientAge={patientAge}
// //   doctorName={doctorName}
// //   userId={userId}
// //   showADTab={showADTab}
// //   activeSubTab={activeSubTab}
// // />
// // )}

// //           {activeTab === "report" && (
// //             <DermReportTab
// //               emrId={emrId}
// //               patientAge={patientAge}
// //               doctorName={doctorName}
// //               userId={userId}
// //               showADTab={showADTab}
// //             />
// //           )}
          
          
          
          
// //           */}


// //           {/* CONTENT */}

// // {activeTab === "summary" && (
// //   <DermSummaryTab
// //     {...reportProps}
// //     activeSubTab={activeSubTab}
// //     onSubmitSuccess={() => setActiveTab("imageViewer")}
// //   />
// // )}

// // {activeTab === "imageViewer" && (
// //   <DermImageViewerTab
// //     emrId={emrId}
// //     patientAge={patientAge}
// //     doctorName={doctorName}
// //     userId={userId}
// //     showADTab={showADTab}
// //     activeSubTab={activeSubTab}
// //   />
// // )}

// // {activeTab === "report" && (
// //   <DermReportTab
// //     emrId={emrId}
// //     patientAge={patientAge}
// //     doctorName={doctorName}
// //     userId={userId}
// //     showADTab={showADTab}
// //     activeSubTab={activeSubTab}
// //   />
// // )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default DermatologyScreen;




// import React, { useEffect, useState } from "react";
// import {
//   useParams,
//   useNavigate,
//   useLocation,
// } from "react-router-dom";
// import "../css/DermatologyScreen.css";

// import DermSummaryTab from "../components/dermatology/DermSummaryTab";
// import DermImageViewerTab from "../components/dermatology/DermImageViewerTab";
// import DermReportTab from "../components/dermatology/DermReportTab";

// import { useAuth } from "../context/AuthContext";

// type ActiveTab = "summary" | "imageViewer" | "report";
// type SubTab = "derma" | "ad";

// export interface ReportRecommendations {
//   none: boolean;
//   followAdvice: boolean;
//   consultDerm: boolean;
// }

// const DermatologyScreen: React.FC = () => {
//   const { emrNumber } = useParams<{ emrNumber: string }>();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { doctor } = useAuth();

//   const emrId = emrNumber ?? "";

//   const sessionId = (location.state as any)?.sessionId;
//   const meta = (location.state as any)?.meta;

//   const patientAge = 4;
//   const doctorName = doctor ? `Dr. ${doctor.name}` : "";
//   const userId = doctor?.id || doctor?.userId || "";

//   const [activeTab, setActiveTab] =
//     useState<ActiveTab>("summary");
//   const [activeSubTab, setActiveSubTab] =
//     useState<SubTab>("derma");

//   // 🔥 NEW FLAGS
//   const [showADTab, setShowADTab] = useState(false);
//   const [showDermaTab, setShowDermaTab] = useState(true);
//   const [loadingFlags, setLoadingFlags] = useState(true);

//   // Shared Report State
//   const [telePrognosis, setTelePrognosis] = useState("");
//   const [medicalAdvice, setMedicalAdvice] = useState("");

//   const [recommendations, setRecommendations] =
//     useState<ReportRecommendations>({
//       none: false,
//       followAdvice: false,
//       consultDerm: false,
//     });

//   // =====================================================
//   // 🔥 USE META INSTEAD OF SCORING API
//   // =====================================================
//   // useEffect(() => {
//   //   if (!meta) {
//   //     console.warn("No meta found");
//   //     setLoadingFlags(false);
//   //     return;
//   //   }

//   //   const ad = meta.adRelevant === true;
//   //   const derma = meta.peRelevant === true;

//   //   console.log("META FLAGS =", meta);

//   //   setShowADTab(ad);
//   //   setShowDermaTab(derma);

//   //   // 🚀 SKIP DERMATOLOGY
//   //   if (!ad && !derma) {
//   //     navigate(`/patient/${emrId}/pediatric-assessment`, {
//   //       state: { sessionId },
//   //     });
//   //     return;
//   //   }

//   //   // Decide default tab
//   //   if (derma) setActiveSubTab("derma");
//   //   else if (ad) setActiveSubTab("ad");

//   //   setLoadingFlags(false);
//   // }, [meta]);



//   useEffect(() => {
//   if (!meta) {
//     console.warn("No meta found");
//     setLoadingFlags(false);
//     return;
//   }

//   // ✅ UPDATED KEYS
//   const ad = meta.showADForm === true;

//   const derma =
//     meta.showPhysicalExaminationForm === true;

//   console.log("META FLAGS =", meta);

//   setShowADTab(ad);
//   setShowDermaTab(derma);

//   // 🚀 SKIP DERMATOLOGY
//   if (!ad && !derma) {
//     navigate(`/patient/${emrId}/pediatric-assessment`, {
//       state: { sessionId },
//     });
//     return;
//   }

//   if (derma) setActiveSubTab("derma");
//   else if (ad) setActiveSubTab("ad");

//   setLoadingFlags(false);
// }, [meta]);

//   const reportProps = {
//     emrId,
//     patientAge,
//     doctorName,
//     userId,
//     telePrognosis,
//     setTelePrognosis,
//     medicalAdvice,
//     setMedicalAdvice,
//     recommendations,
//     setRecommendations,
//     showADTab,
//   };

//   if (loadingFlags) {
//     return <div className="loading-state">Loading...</div>;
//   }

//   return (
//     <div className="derm-screen">
//       {/* HEADER */}
//       <div className="screen-header-row">
//         <button
//           onClick={() => navigate("/queue/dermatology")}
//           className="back-button"
//         >
//           &larr; Back to Patient List
//         </button>

//         <div className="patient-info">
//           <span>
//             <strong>EMR Number:</strong> {emrId}
//           </span>

//           <span>
//             <strong>Age:</strong> {patientAge} years
//           </span>
//         </div>
//       </div>

//       {/* MAIN */}
//       <div className="derm-main-layout">
//         {/* SIDEBAR */}
//         <div className="derm-sidebar">
//           <button
//             className={`derm-tab ${
//               activeTab === "summary" ? "active" : ""
//             }`}
//             onClick={() => setActiveTab("summary")}
//           >
//             Summary
//           </button>

//           <button
//             className={`derm-tab ${
//               activeTab === "imageViewer" ? "active" : ""
//             }`}
//             onClick={() => setActiveTab("imageViewer")}
//           >
//             Images
//           </button>

//           <button
//             className={`derm-tab ${
//               activeTab === "report" ? "active" : ""
//             }`}
//             onClick={() => setActiveTab("report")}
//           >
//             Report
//           </button>
//         </div>

//         {/* RIGHT */}
//         <div className="derm-right-content">

//           {/* SUB TABS */}
//           {(activeTab === "summary" ||
//             activeTab === "imageViewer" ||
//             activeTab === "report") && (
//             <div className="derm-sub-tabs-container">

//               {/* 🔥 DERMA TAB */}
//               {showDermaTab && (
//                 <button
//                   className={`derm-sub-tab ${
//                     activeSubTab === "derma"
//                       ? "active"
//                       : ""
//                   }`}
//                   onClick={() => setActiveSubTab("derma")}
//                 >
//                   Derma Symptoms
//                 </button>
//               )}

//               {/* 🔥 AD TAB */}
//               {showADTab && (
//                 <button
//                   className={`derm-sub-tab ${
//                     activeSubTab === "ad"
//                       ? "active"
//                       : ""
//                   }`}
//                   onClick={() => setActiveSubTab("ad")}
//                 >
//                   AD Symptoms
//                 </button>
//               )}
//             </div>
//           )}

//           {/* CONTENT */}
//           {activeTab === "summary" && (
//             <DermSummaryTab
//               {...reportProps}
//               activeSubTab={activeSubTab}
//             />
//           )}

//           {activeTab === "imageViewer" && (
//             <DermImageViewerTab
//               emrId={emrId}
//               patientAge={patientAge}
//               doctorName={doctorName}
//               userId={userId}
//               showADTab={showADTab}
//               activeSubTab={activeSubTab}
//             />
//           )}

//           {activeTab === "report" && (
//             <DermReportTab
//               emrId={emrId}
//               patientAge={patientAge}
//               doctorName={doctorName}
//               userId={userId}
//               showADTab={showADTab}
//               activeSubTab={activeSubTab}
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DermatologyScreen;




import React, { useEffect, useState } from "react";
import {
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import "../css/DermatologyScreen.css";

import DermSummaryTab from "../components/dermatology/DermSummaryTab";
import DermImageViewerTab from "../components/dermatology/DermImageViewerTab";
import DermReportTab from "../components/dermatology/DermReportTab";

import { useAuth } from "../context/AuthContext";

type ActiveTab = "summary" | "imageViewer" | "report";
type SubTab = "derma" | "ad";

export interface ReportRecommendations {
  none: boolean;
  followAdvice: boolean;
  consultDerm: boolean;
}

const DermatologyScreen: React.FC = () => {
  const { emrNumber } = useParams<{ emrNumber: string }>();

  const navigate = useNavigate();
  const location = useLocation();

  const { doctor } = useAuth();

  const emrId = emrNumber ?? "";

  const sessionId = (location.state as any)?.sessionId;

  const meta = (location.state as any)?.meta;

  const patientAge = 4;

  const doctorName = doctor ? `Dr. ${doctor.name}` : "";

  const userId = doctor?.id || doctor?.userId || "";

  const [activeTab, setActiveTab] =
    useState<ActiveTab>("summary");

  const [activeSubTab, setActiveSubTab] =
    useState<SubTab>("derma");

    const [dermaSubmitted, setDermaSubmitted] =
  useState(false);

const [adSubmitted, setAdSubmitted] =
  useState(false);

  // =========================================================
  // FLAGS
  // =========================================================

  const [showADTab, setShowADTab] = useState(false);

  const [showDermaTab, setShowDermaTab] = useState(true);

  const [loadingFlags, setLoadingFlags] =
    useState(true);

  // =========================================================
  // PE / DERMA STATES
  // =========================================================

  const [peTeleDiagnosis, setPeTeleDiagnosis] =
    useState("");

  const [peMedicalAdvice, setPeMedicalAdvice] =
    useState("");

  const [peRecommendations, setPeRecommendations] =
    useState<ReportRecommendations>({
      none: false,
      followAdvice: false,
      consultDerm: false,
    });

  // =========================================================
  // AD STATES
  // =========================================================

  const [adTeleDiagnosis, setAdTeleDiagnosis] =
    useState("");

  const [adMedicalAdvice, setAdMedicalAdvice] =
    useState("");

  const [adRecommendations, setAdRecommendations] =
    useState<ReportRecommendations>({
      none: false,
      followAdvice: false,
      consultDerm: false,
    });

  // =========================================================
  // FLAGS LOGIC
  // =========================================================

  useEffect(() => {
    if (!meta) {
      console.warn("No meta found");

      setLoadingFlags(false);

      return;
    }

    const ad = meta.showADForm === true;

    const derma =
      meta.showPhysicalExaminationForm === true;

    console.log("META FLAGS =", meta);

    setShowADTab(ad);

    setShowDermaTab(derma);

    // SKIP DERMATOLOGY
    if (!ad && !derma) {
      navigate(`/patient/${emrId}/pediatric-assessment`, {
        state: { sessionId },
      });

      return;
    }

    // DEFAULT TAB
    if (derma) {
      setActiveSubTab("derma");
    } else if (ad) {
      setActiveSubTab("ad");
    }

    setLoadingFlags(false);
  }, [meta]);

  // =========================================================
  // DYNAMIC REPORT PROPS
  // =========================================================

  const reportProps = {
    emrId,
    patientAge,
    doctorName,
    userId,

    telePrognosis:
      activeSubTab === "ad"
        ? adTeleDiagnosis
        : peTeleDiagnosis,

    setTelePrognosis:
      activeSubTab === "ad"
        ? setAdTeleDiagnosis
        : setPeTeleDiagnosis,

    medicalAdvice:
      activeSubTab === "ad"
        ? adMedicalAdvice
        : peMedicalAdvice,

    setMedicalAdvice:
      activeSubTab === "ad"
        ? setAdMedicalAdvice
        : setPeMedicalAdvice,

    recommendations:
      activeSubTab === "ad"
        ? adRecommendations
        : peRecommendations,

    setRecommendations:
      activeSubTab === "ad"
        ? setAdRecommendations
        : setPeRecommendations,

    showADTab,
  };

  if (loadingFlags) {
    return <div className="loading-state">Loading...</div>;
  }

  return (
    <div className="derm-screen">

      {/* HEADER */}

      <div className="screen-header-row">
        <button
          onClick={() => navigate("/queue/dermatology")}
          className="back-button"
        >
          &larr; Back to Patient List
        </button>

        <div className="patient-info">
          <span>
            <strong>EMR Number:</strong> {emrId}
          </span>

          <span>
            <strong>Age:</strong> {patientAge} years
          </span>
        </div>
      </div>

      {/* MAIN */}

      <div className="derm-main-layout">

        {/* SIDEBAR */}

<div className="derm-sidebar">

  {showDermaTab && (
    <button
      className={`derm-tab ${
        activeSubTab === "derma" ? "active" : ""
      }`}
      onClick={() => setActiveSubTab("derma")}
    >
      Derma Symptoms
    </button>
  )}

  {showADTab && (
    <button
      className={`derm-tab ${
        activeSubTab === "ad" ? "active" : ""
      }`}
      onClick={() => setActiveSubTab("ad")}
    >
      AD Symptoms
    </button>
  )}

</div>

        {/* RIGHT */}

        <div className="derm-right-content">

          {/* SUB TABS */}

<div className="derm-sub-tabs-container">

  <button
    className={`derm-sub-tab ${
      activeTab === "summary" ? "active" : ""
    }`}
    onClick={() => setActiveTab("summary")}
  >
    Summary
  </button>

  <button
    className={`derm-sub-tab ${
      activeTab === "imageViewer" ? "active" : ""
    }`}
    onClick={() => setActiveTab("imageViewer")}
  >
    Images
  </button>

  <button
    className={`derm-sub-tab ${
      activeTab === "report" ? "active" : ""
    }`}
    onClick={() => setActiveTab("report")}
  >
    Report
  </button>

</div>

          {/* SUMMARY */}

          {activeTab === "summary" && (
            <DermSummaryTab
              {...reportProps}
              activeSubTab={activeSubTab}
            />
          )}

          {/* IMAGES */}

          {activeTab === "imageViewer" && (
            <DermImageViewerTab
              emrId={emrId}
              patientAge={patientAge}
              doctorName={doctorName}
              userId={userId}
              showADTab={showADTab}
              activeSubTab={activeSubTab}
            />
          )}

          {/* REPORT */}

          {activeTab === "report" && (
 <DermReportTab
  {...reportProps}
  sessionId={sessionId}
  activeSubTab={activeSubTab}

  dermaSubmitted={dermaSubmitted}
  setDermaSubmitted={setDermaSubmitted}

  adSubmitted={adSubmitted}
  setAdSubmitted={setAdSubmitted}
/>
          )}
        </div>
      </div>
    </div>
  );
};

export default DermatologyScreen;